(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const stored = () => { try { return sessionStorage.getItem('enqore-motion'); } catch { return null; } };
  let paused = !window.enqoreMotionAllowed || reduced.matches || stored() === 'off';
  let revealObserver;
  const transition = document.querySelector('.page-transition');
  const transitionVideo = transition?.querySelector('video');
  let timer;
  function syncMotion() {
    document.documentElement.classList.toggle('motion-enabled', !paused);
    document.querySelectorAll('.motion-toggle').forEach(b => {
      b.textContent = 'Mouvement : ' + (paused ? 'OFF' : 'ON');
      b.setAttribute('aria-label', paused ? 'Activer les animations' : 'Mettre les animations en pause');
      b.setAttribute('aria-pressed', String(!paused));
    });
    document.querySelectorAll('.trio-pause').forEach(b => b.textContent = paused ? 'Relancer les animations' : 'Mettre les animations en pause');
    document.querySelectorAll('.ambient').forEach(v => { if (paused) v.pause(); else v.play().catch(() => {}); });
    if (paused) { document.body.classList.remove('js-motion'); revealObserver?.disconnect(); }
    try { sessionStorage.setItem('enqore-motion', paused ? 'off' : 'on'); } catch {}
  }
  function observeReveals(root = document) {
    if (paused || window.Shopify?.designMode || !('IntersectionObserver' in window)) return;
    document.body.classList.add('js-motion');
    revealObserver ||= new IntersectionObserver(entries => entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('visible'); revealObserver.unobserve(e.target); }
    }), { threshold: .08 });
    root.querySelectorAll('.reveal').forEach(e => revealObserver.observe(e));
  }
  const paths = { '↗':'M5 19 19 5M5 5h14v14', '↘':'M5 5l14 14M5 19h14V5', '↓':'M12 4v16M5 13l7 7 7-7', '→':'M4 12h16M13 5l7 7-7 7' };
  function drawDirections(root = document.body) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), nodes = [];
    while (walker.nextNode()) { const n = walker.currentNode; if (/[↗↘↓→]/u.test(n.nodeValue) && !n.parentElement?.closest('script,style,svg,.ui-direction,textarea')) nodes.push(n); }
    for (const n of nodes) {
      const fragment = document.createDocumentFragment();
      n.nodeValue.split(/([↗↘↓→])/u).forEach(part => {
        if (!paths[part]) { fragment.append(document.createTextNode(part)); return; }
        const icon = document.createElement('i'); icon.className = 'ui-direction'; icon.setAttribute('aria-hidden','true');
        icon.innerHTML = `<svg class="direction-drawing" viewBox="0 0 24 24" focusable="false"><path d="${paths[part]}"/></svg>`;
        fragment.append(icon);
      });
      n.replaceWith(fragment);
    }
  }
  const config = JSON.parse(document.querySelector('#enqore-navigation')?.textContent || '{}');
  function destination(href) {
    const url = new URL(href, location.href);
    if (url.origin !== location.origin) return null;
    const view = url.searchParams.get('view');
    if (view === 'enqore-1') return 'sun';
    if (view === 'enqore-2') return 'city';
    if (view === 'enqore-maison') return 'house';
    for (const [scene, path] of Object.entries(config)) {
      const target = new URL(path, location.href);
      if (url.pathname === target.pathname && view === target.searchParams.get('view')) return scene;
    }
    return null;
  }
  function prepare(scene) {
    const el = transition?.querySelector('.scene-' + scene);
    el?.querySelectorAll('img[data-src]').forEach(img => { img.src = img.dataset.src; delete img.dataset.src; });
    if (scene === 'city' && transitionVideo && transitionVideo.preload === 'none') { transitionVideo.preload = 'auto'; transitionVideo.load(); }
  }
  function reset() { clearTimeout(timer); timer = null; transition?.classList.remove('show'); transitionVideo?.pause(); }
  document.addEventListener('click', e => {
    if (e.target.closest('.motion-toggle,.trio-pause')) { paused = !paused; syncMotion(); return; }
    const link = e.target.closest('a[href]');
    if (!link || paused || window.Shopify?.designMode || !transition || e.defaultPrevented || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || e.button !== 0 || link.target === '_blank' || link.hasAttribute('download')) return;
    const scene = destination(link.href), target = new URL(link.href), current = new URL(location.href);
    if (!scene || (current.pathname === target.pathname && current.searchParams.get('view') === target.searchParams.get('view'))) return;
    e.preventDefault(); if (timer) return;
    prepare(scene); transition.dataset.scene = scene; transition.classList.add('show');
    if (scene === 'city' && transitionVideo) { transitionVideo.currentTime = 0; transitionVideo.play().catch(() => {}); }
    timer = setTimeout(() => location.assign(link.href), 420);
  });
  for (const event of ['pointerover','focusin']) document.addEventListener(event, e => { const link=e.target.closest('a[href]'); if (link && !paused) { const scene=destination(link.href); if (scene) prepare(scene); } });
  window.addEventListener('pageshow', reset);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') reset(); });
  reduced.addEventListener('change', () => { if (reduced.matches) { paused=true; reset(); syncMotion(); } });
  document.addEventListener('shopify:section:load', e => { drawDirections(e.target); observeReveals(e.target); syncMotion(); });
  drawDirections(); observeReveals(); syncMotion();
})();
